var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMautic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "303 -5 350 360",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brandmark"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 5,
    d: "M478.822,350.368c-96.277,0-174.89-78.318-174.89-174.89c0-96.572,78.612-174.89,174.89-174.89 c23.26,0,45.931,4.417,67.129,13.543c5.889,2.65,8.833,9.422,6.478,15.605c-2.649,5.888-9.421,8.833-15.604,6.477 c-18.549-7.655-37.98-11.482-58.002-11.482c-83.323,0-151.041,67.718-151.041,151.041S395.5,326.813,478.822,326.813 c83.323,0,151.041-67.718,151.041-151.041c0-17.96-2.944-35.332-9.127-51.819c-2.355-6.183,0.883-12.955,7.066-15.31 c6.183-2.355,12.954,0.883,15.31,7.066c7.066,19.138,10.6,39.453,10.6,60.063C653.712,271.756,575.395,350.368,478.822,350.368z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    stroke: "currentColor",
    points: "555.373,157.519 528.286,185.783 543.302,249.085 577.455,249.085  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    stroke: "currentColor",
    points: "544.186,73.901 553.606,83.323 478.822,162.523 414.932,96.866 378.128,249.085 412.282,249.085 432.598,164.584 478.822,214.932 577.75,107.171 587.172,116.888 596.593,63.596  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMautic);
export default __webpack_public_path__ + "static/media/mautic.9f339a76402821abe5a68355e9a9c74a.svg";
export { ForwardRef as ReactComponent };